// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"b53d5bc4","675":"1b4019ba","724":"d2f87569","959":"c47de7d4","998":"276d47fd"}[chunkId] + ".chunk.js";
};